
import { Progress } from '@/components/ui/progress';
import { useEffect, useState } from 'react';

interface ProcessingProgressProps {
  isProcessing: boolean;
}

const ProcessingProgress = ({ isProcessing }: ProcessingProgressProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!isProcessing) {
      setProgress(0);
      return;
    }

    // Simulate progress from 0 to 90% while processing
    setProgress(0);
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 90) {
          clearInterval(interval);
          return 90;
        }
        return prev + Math.random() * 15;
      });
    }, 300);

    return () => clearInterval(interval);
  }, [isProcessing]);

  // Jump to 100% when processing is complete
  useEffect(() => {
    if (!isProcessing && progress > 0) {
      setProgress(100);
      const timeout = setTimeout(() => {
        setProgress(0);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [isProcessing, progress]);

  if (!isProcessing && progress === 0) return null;

  return (
    <div className="mb-8 space-y-4 animate-fade-in">
      <div className="flex items-center justify-between text-[#6B4EE6]">
        <span className="font-medium">Processing images...</span>
        <span className="text-sm">{Math.round(progress)}%</span>
      </div>
      <Progress 
        value={progress} 
        className="h-2 bg-[#E5DEFF]"
      />
    </div>
  );
};

export default ProcessingProgress;
